import { useAvatar } from '@lib/core/src/components/useAvatar';
import { getInitials } from '@lib/core/src/utils/string-util';
import { Avatar } from '@mui/material';

import { getHoursAndMinutesFromNumberOfSeconds } from '@/utils/dateUtil';

import {
  Row,
  TranscriptDate,
  TranscriptSpeaker,
  TranscriptText,
  TranscriptListItem,
  StartStack,
  SpaceBetweenRow
} from './TranscriptStyles';
import { TranscriptEntryWithId } from './types';

interface TranscriptRowProps {
  entry: TranscriptEntryWithId;
  onTimeClicked: (time: number) => void;
  markedId: string;
}

const TranscriptRow = ({ entry, onTimeClicked, markedId }: TranscriptRowProps) => {
  const { getAvatarStyle } = useAvatar();
  const avatarStyle = getAvatarStyle(String(entry.speaker_id));

  return (
    <TranscriptListItem
      key={entry.id}
      onClick={() => onTimeClicked(entry?.words?.[0]?.start_timestamp)}
      id={entry.id}
      isActive={markedId === entry.id}
    >
      <StartStack>
        <SpaceBetweenRow>
          <Row>
            {entry.speaker ? (
              <>
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    fontSize: 10,
                    bgcolor: avatarStyle.backgroundColor,
                    color: avatarStyle.color
                  }}
                >
                  {getInitials(entry.speaker)}
                </Avatar>

                <TranscriptSpeaker>{entry.speaker}</TranscriptSpeaker>
              </>
            ) : (
              ''
            )}
          </Row>
          <TranscriptDate className="transcript-date" isActive={markedId === entry.id}>
            {getHoursAndMinutesFromNumberOfSeconds(entry.words?.[0]?.start_timestamp)}
          </TranscriptDate>
        </SpaceBetweenRow>

        {entry.words?.[0]?.text && <TranscriptText>{entry.words?.[0]?.text}</TranscriptText>}
      </StartStack>
    </TranscriptListItem>
  );
};

export default TranscriptRow;
